import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Navigation } from 'app/core/navigation/navigation.types';
import { ZuperNavigationItem } from '@zuper/components/zuper-navigation';
import { compactNavigation, defaultNavigation, futuristicNavigation, horizontalNavigation } from './data';
import { cloneDeep } from 'lodash-es';

@Injectable({
    providedIn: 'root'
})
export class NavigationService
{
    _navigation: BehaviorSubject<Navigation> = new BehaviorSubject<Navigation>(null);


    private readonly _compactNavigation: ZuperNavigationItem[] = compactNavigation;
    private readonly _defaultNavigation: ZuperNavigationItem[] = defaultNavigation;
    private readonly _futuristicNavigation: ZuperNavigationItem[] = futuristicNavigation;
    private readonly _horizontalNavigation: ZuperNavigationItem[] = horizontalNavigation;

    /**
     * Constructor
     */
    constructor()
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for navigation
     */
    get navigation$(): Observable<Navigation>
    {
        return this._navigation.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all navigation data
     */
    getAllNavigation(): void
    {
        // Fill compact navigation children using the default navigation
        this._compactNavigation.forEach((compactNavItem) => {
            this._defaultNavigation.forEach((defaultNavItem) => {
                if ( defaultNavItem.id === compactNavItem.id )
                {
                    compactNavItem.children = cloneDeep(defaultNavItem.children);
                }
            });
        });

        // Fill futuristic navigation children using the default navigation
        this._futuristicNavigation.forEach((futuristicNavItem) => {
            this._defaultNavigation.forEach((defaultNavItem) => {
                if ( defaultNavItem.id === futuristicNavItem.id )
                {
                    futuristicNavItem.children = cloneDeep(defaultNavItem.children);
                }
            });
        });

        // Fill horizontal navigation children using the default navigation
        this._horizontalNavigation.forEach((horizontalNavItem) => {
            this._defaultNavigation.forEach((defaultNavItem) => {
                if ( defaultNavItem.id === horizontalNavItem.id )
                {
                    horizontalNavItem.children = cloneDeep(defaultNavItem.children);
                }
            });
        });
        this._navigation.next({
            compact   : cloneDeep(this._compactNavigation),
            default   : cloneDeep(this._defaultNavigation),
            futuristic: cloneDeep(this._futuristicNavigation),
            horizontal: cloneDeep(this._horizontalNavigation)
        });
    }
}
